// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__as6a+","title":"Advt_title__j+rtU","qrsWrapper":"Advt_qrsWrapper__mr2iS","qrCode":"Advt_qrCode__bOdag"};